import '@/styles/backend/main.scss';

import {loadComponents} from '@/views/component-loader';

import 'swiper/css/bundle';
import 'vueperslides/dist/vueperslides.css';

loadComponents();
